import { useLocation, useNavigate } from 'react-router-dom';

export function useQueryParams() {
  const navigate = useNavigate();
  const location = useLocation();

  const clearQueryParams = () => {
    const { pathname } = location;
    navigate(pathname, { replace: true });
  };

  return { clearQueryParams };
}
